import type {Sorting} from 'components/dataTable/types';

export const mapSortingConfigToString = (sortingConfig: Sorting): string => {
  return `${sortingConfig.field},${sortingConfig.sort}`;
};
